import React, { useState, useEffect } from "react";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import {
  fundMasterSubType,
  fundMasterType,
  fundUtilization,
  getAllBlocksFromDistrict,
  school_name_block_wise,
} from "../api/Users";
import { TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";

const FundUtilization = ({ userData, role }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [Block, setBlock] = useState("");
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [Allblocks, setAllBlocks] = useState([]);
  const [schoolId, setSchoolId] = useState("");
  const [Remark, setRemarks] = useState("");
  const [Amount, setAmount] = useState("");
  const [fundTypes, setFundTypes] = useState([]);
  const [fundSubTypes, setFundSubTypes] = useState([]);
  const [selectedFundType, setSelectedFundType] = useState("");
  const [selectedFundSubType, setSelectedFundSubType] = useState("");
  const [documentFile, setDocumentFile] = useState(null);

  useEffect(() => {
    const district_code = userData.data.district_code;
    getAllBlocksFromDistrict(district_code)
      .then((res) => {
        if (res.status === "success") {
          setAllBlocks(res.data.new_asset_query);
        } else {
          setAllBlocks([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching blocks:", error);
        setAllBlocks([]);
      });

    fundMasterType()
      .then((response) => {
        if (response.status === "success") {
          setFundTypes(response.data);
        } else {
          setFundTypes([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching fund types:", error);
        setFundTypes([]);
      });

    fundMasterSubType()
      .then((response) => {
        if (response.status === "success") {
          setFundSubTypes(response.data);
        } else {
          setFundSubTypes([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching fund types:", error);
        setFundSubTypes([]);
      });
  }, [userData.data.district_code]);

  const handleBlockChange = (e) => {
    setBlock(e.target.value);
    setAllSchoolNames([]);

    const data = {
      block_code: e.target.value,
    };

    school_name_block_wise(data)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.result);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  const handleSchoolName = (e) => {
    try {
      setSchoolId(e.target.value);
    } catch (error) {
      console.error("Error parsing JSON in handleSchoolName:", error);
    }
  };

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("district_code", userData.data.district_code);
    formData.append("block_code", Block);
    formData.append("school_id", schoolId);
    formData.append("fund_master_type_id", selectedFundType);
    formData.append("fund_master_sub_type_id", selectedFundSubType);
    formData.append("amount", Amount);
    formData.append("description", Remark);
    formData.append("file", documentFile);

    fundUtilization(formData)
      .then((response) => {
        if (response.status === "success") {
          toast.success(response.message);
          setIsLoading(false);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          toast.error("Submission failed. Please try again.");
        }
      })
      .catch((error) => {
        toast.error("Error submitting form. Please try again later.");
      });
  };

  const handleFundTypeChange = (e) => {
    setSelectedFundType(e.target.value);
  };
  const handleFundSubTypeChange = (e) => {
    setSelectedFundSubType(e.target.value);
  };
  const handleAmount = (e) => {
    setAmount(e.target.value);
  };
  const handleRemarks = (e) => {
    setRemarks(e.target.value);
  };
  const handleDocumentChange = (e) => {
    setDocumentFile(e.target.files[0]);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div className="my-5 col-12 d-flex justify-content-between align-items-center">
            <h5 className="">{t("Fund Utilization")}</h5>
          </div>{" "}
        </div>

        <div className="my-3 col-12 d-flex justify-content-between align-items-center">
          <div className="col-2 mx-2">
            <label className="form-label">{t("Block")} </label>
            <select
              name="GP" // value={AssetsType}
              className="common-input form-select"
              onChange={handleBlockChange}
              required
            >
              <option value="">Select Block</option>
              {Allblocks &&
                Allblocks.map((row, index) => (
                  <option key={index} value={row.code}>
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-2 mx-2">
            <label className="form-label">{t("School Name")} </label>
            <select
              name="SchoolName" // value={AssetsType}
              className="common-input form-select"
              onChange={handleSchoolName}
              required
            >
              <option value="">Select School</option>
              {AllSchoolNames &&
                AllSchoolNames.map((row, index) => (
                  <option value={row.school_id}>{row.school_name}</option>
                ))}
            </select>
          </div>
          <div className="col-2 mx-2">
            <label className="form-label">{t("Fund Type")}</label>
            <select
              name="asset_type_id"
              className="common-input form-select"
              onChange={handleFundTypeChange}
              value={selectedFundType}
              required
            >
              <option value="">{t("Select Fund Type")}</option>
              {fundTypes &&
                fundTypes.map((row, index) => (
                  <option key={index} value={row.id}>
                    {row.head_name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-2 mx-2">
            <label className="form-label">{t("Fund Sub Type")}</label>
            <select
              name="asset_sub_type_id"
              className="common-input form-select"
              onChange={handleFundSubTypeChange}
              value={selectedFundSubType}
              required
            >
              <option value="">{t("Select Fund Sub Type")}</option>
              {fundSubTypes &&
                fundSubTypes.map((row, index) => (
                  <option key={index} value={row.id}>
                    {row.sub_type_name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-2 mx-2">
            <label className="form-label">{t("Amount")}</label>
            <input
              type="number"
              onChange={handleAmount}
              className="common-input form-control"
            />
          </div>
        </div>
        <div
          className="my-3 d-flex justify-content-between  align-items-center"
          style={{ flexDirection: "row" }}
        >
          <div className="col-7 mx-2">
            <label className="form-label">{t("Remarks")}</label>
            <textarea
              className="common-input form-control"
              onChange={handleRemarks}
              rows="2"
            />
          </div>
          <div className="col-4 mt-4 mx-2">
            <label className="form-label">
              {t("Documents")}
              <span className="text-danger"> *</span>
            </label>
            <input
              type="file"
              name="doc"
              className="form-control"
              onChange={handleDocumentChange}
              accept=".pdf"
              required
            />
          </div>
        </div>
        <div className="col-12 d-flex justify-content-end px-2 mt-4">
          <button
            type="submit"
            className="col-2 btn btn-primary mt-4"
            onClick={handleSubmit}
          >
            {t("Submit")}
          </button>
        </div>
      </div>
    </>
  );
};

export default FundUtilization;
